import React from "react";
import ResumeJourney from "./resume/ResumeJourney";
import "./App.css";

function App({ routeMap }) {
  return (
    <div className="dropoff-recovery-journey-container">
      <ResumeJourney routeMap={routeMap} />
    </div>
  );
}

export default App;
